export default "__VITE_ASSET__C2qDEwr3__"